/* eslint-disable */

import { createRouter, createWebHashHistory } from 'vue-router';
import Lenis from "@/lenis";
import Main from '@/views/Main.vue';
import About from '@/views/About.vue';
import RLTS from '@/views/Projet-RLTS.vue';
import Legals from '@/views/Legals.vue';
import Contact from '@/views/Contact.vue';
import NotFound from '@/views/NotFound.vue';

const routes = [
    { path: '/', name: 'Home', component: Main, meta: { title: 'Verpillon Numa - Accueil' },},
    { path: '/about', name: 'About', component: About, meta: { title: 'Verpillon Numa - À propos' },},
    { path: '/rlts', name: 'Projet-RLTS', component: RLTS, meta: { title: 'Verpillon Numa - RLTS' },},
    { path: '/legals', name: 'Legals', component: Legals, meta: { title: 'Verpillon Numa - Mentions légales' },},
    { path: '/contact', name: 'Contact', component: Contact, meta: { title: 'Verpillon Numa - Contact' },},
    { path: '/:pathMatch(.*)*', name: 'NotFound', component: NotFound, meta: { title: 'Verpillon Numa - Erreur 404' },}, // Route 404
];

const router = createRouter({
    history: createWebHashHistory(), // Utilise le hash pour la navigation (#/about)
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (to.hash) {
            return { el: to.hash };
        }
        if (Lenis){
            Lenis.stop()
        }
        window.scrollTo(0, 0);
        if (Lenis){
            Lenis.start()
        }
    },
});

router.beforeEach((to, from, next) => {
    // Définit le titre à partir des métadonnées ou utilise un titre par défaut
    document.title = to.meta.title || 'Verpillon Numa - Site Web';
    next();
});


export default router;